import React from "react";
import "./Shipping-Policy.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet-async";
// import { FiHeadphones } from "react-icons/fi";
const ShippingPolicy = () => {
  return (
    <>
    
<Helmet>
  <title>Shipping Policy | Astro Logical Solutions</title>

  <meta
    name="description"
    content="Learn about shipping, order processing, delivery timelines and shipment updates for purchases from Astro Logical Solutions."
  />

  <link
    rel="canonical"
    href="https://astrologicalsolutions.in/Shipping-Policy"
  />

  <meta
    name="robots"
    content="index, follow, max-image-preview:large"
  />

  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Shipping Policy | Astro Logical Solutions"
  />
  <meta
    property="og:description"
    content="Find information about order processing, shipping and delivery at Astro Logical Solutions."
  />
  <meta
    property="og:url"
    content="https://astrologicalsolutions.in/Shipping-Policy"
  />
  <meta
    property="og:site_name"
    content="Astro Logical Solutions"
  />
</Helmet>

      <Header />
      <div className="shipping-page">
        <section className="shipping-hero">
          <h1 className="page-title">
            Shipping Policy
            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          </h1>
          <div className="hero-card">
            <span className="hero-badge">SHIPPING &amp; DELIVERY</span>
            <h2>Securely Packed, Carefully Delivered</h2>
            <div className="hero-stars">
              <span>✦</span>
              <span>✦</span>
              <span>✦</span>
            </div>
            <p className="hero-description">
              Every Astro Logical Solutions order is carefully packed and
              securely shipped with reliable tracking. We ensure your order
              reaches you safely and on time, with delivery available across
              India.
            </p>
            <div className="shipping-points">
              <span>Free shipping across India</span>
              <span>Fully insured in transit</span>
              <span>Dispatch within 4 business days</span>
              <span>Live tracking on every order</span>
            </div>
          </div>
        </section>
        <section className="shipping-details">
          <div className="content-section">
            <div className="section-heading">
              <h3>Dispatch Time</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              At <strong>Astro Logical Solutions</strong>, every order is
              prepared with care and dispatched within{" "}
              <strong>4 business days</strong> of confirmation. Personalised and
              specially prepared products may require additional preparation
              time. We keep you updated at every stage, ensuring your spiritual
              and astrological essentials are handled with care from our hands
              to yours.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Delivery Timelines at a Glance</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              At <strong>Astro Logical Solutions</strong>, we carefully prepare
              and dispatch every order with attention to detail. Delivery
              timelines are calculated from the{" "}
              <strong>date of dispatch</strong> and may vary based on your
              location, courier services, weather, or other unforeseen
              circumstances. Once your order is on its way, you can conveniently
              follow its journey through our{" "}
              <span className="link-text">Order Tracking </span>
              page.
            </p>
            <div className="timeline-table-wrapper">
              <table className="timeline-table">
                <thead>
                  <tr>
                    <th>Stage</th>
                    <th>Timeline</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Dispatch (all orders)</strong>
                    </td>
                    <td>Within 4 business days of order confirmation</td>
                    <td>
                      Customised / personalised / energised items may need a
                      little extra handling time
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Delivery within India</strong>
                    </td>
                    <td>7–15 days from dispatch</td>
                    <td>Free shipping — no minimum order value</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Shipping Within India</h3>
              <div className="heading-line"></div>
            </div>

            <p>
              We offer{" "}
              <strong>
                free shipping across India with no minimum order value
              </strong>
              . Orders are typically delivered within{" "}
              <strong>7–15 days from dispatch</strong>. Every parcel is securely
              packaged, fully insured in transit, and shipped with a tracking
              link so you can easily follow your order until it reaches
              you.{" "}
            </p>

            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Free &amp; insured</h4>
                <p>
                  No shipping charge anywhere in India, and every order is fully
                  insured until it reaches you.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Trusted couriers</h4>

                <p>
                  Delivered through reliable partners including Bluedart,
                  Shiprocket and Aftership for timely, safe transit.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Tracked end-to-end</h4>

                <p>
                  You receive a tracking link by email/SMS and can also track
                  from our <span className="link-text">Order Tracking</span>{" "}
                  page.
                </p>
              </div>
            </div>
          </div>
          <div className="content-section order-tracking-section">
            <div className="section-heading">
              <h3>Order Tracking</h3>
              <div className="heading-line"></div>
            </div>

            <p>
              Once your order is dispatched, you’ll receive your tracking
              details by email or SMS. You can easily check your order status
              through our <span className="link-text">Order Tracking</span>{" "}
              page, or contact us on <span className="link-text">WhatsApp</span>{" "}
              for a quick update.
            </p>
          </div>
          <div className="content-section delivery-address-section">
            <div className="section-heading">
              <h3>Delivery Address &amp; Location</h3>
              <div className="heading-line"></div>
            </div>

            <p>
              Please ensure your delivery details are{" "}
              <strong>complete and accurate at checkout</strong>. We deliver
              only to valid residential or business addresses and do not ship to
              PO Boxes, malls, hotels, or other public locations. If you need to
              make any changes to your address, please contact our support team
              before your order is dispatched.
            </p>

            <p className="address-note">
              Providing the correct delivery information is important for smooth
              and timely order fulfilment. We are not responsible for delays or
              delivery issues caused by incorrect, incomplete, or outdated
              address details. Customers are responsible for ensuring that the
              delivery address provided at checkout is accurate and up to date.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>What to Expect at Delivery</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              <p>
                <strong>ID Verification:</strong> High-value orders may require
                ID verification and a signature at delivery. If you are
                unavailable, an authorised person may receive the package for
                you. Please ensure the order is safely received, as we cannot be
                responsible for issues caused by failure to properly accept the
                delivery.
              </p>
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Missed Delivery, Undeliverable Parcels & RTO</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Our courier partner generally makes{" "}
              <strong>up to three delivery attempts</strong> to complete your
              order. If the parcel cannot be delivered after these attempts, it
              may be returned to Astro Logical Solutions as RTO (Return to
              Origin). For delivery attempts, rescheduling, or courier-related
              queries, please contact the courier partner at the earliest. You
              can also reach <strong>Astro Logical Solutions</strong> at{" "}
              <b>support@astrologicalsolutions.in</b> for assistance. If your
              order does not arrive within the expected delivery period, please
              contact us within <strong>30 days of purchase</strong> so that we
              can review the issue and, where applicable, arrange a re-shipment
              or refund in accordance with our Refund Policy.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Damaged, Missing or Lost in Transit</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Every order from <strong>Astro Logical Solutions</strong> is
              securely insured during transit. If your parcel arrives with
              visible damage or signs of tampering, please refuse the delivery
              and notify us as soon as possible. For damaged, incorrect, or
              missing items, please record a continuous unboxing video starting
              before the sealed package is opened. This video is required as
              supporting evidence to help us verify the issue and process your
              claim efficiently. Please report any such concern within the
              applicable return period mentioned in our Refund Policy. Verified
              transit-related loss or damage will be addressed through an
              appropriate repair, replacement, or refund, as applicable.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Delays & Force Majeure</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              At <strong>Astro Logical Solutions</strong>, we always try to
              deliver orders within the estimated timelines. However, unexpected
              situations such as natural calamities, public holidays, government
              restrictions, strikes, transport issues, or other events beyond
              our control may cause delays. Such circumstances may be treated as{" "}
              <strong>Force Majeure Events</strong>. If a significant delay
              occurs, we will keep you informed and share updates regarding the
              revised delivery schedule. Delivery timelines are estimates and
              cannot be guaranteed in every situation. While we are not
              responsible for delays caused by such unforeseen circumstances, we
              will make reasonable efforts to dispatch and deliver your order as
              soon as possible.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Cancellations</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Orders can be cancelled <strong>before dispatch</strong> by
              contacting our support team through WhatsApp or email at{" "}
              <a href="mailto:support@gemsmantra.com" className="link-text">
                support@astrologicalsolutions.in
              </a>{" "}
              as early as possible. We will make every reasonable effort to stop
              the shipment before it leaves our facility.For{" "}
              <b>customised or personalised items</b>, once the design is
              approved and making has begun, the making charges are
              non-refundable. Full details are in our{" "}
              <b>Refund & Cancellation Policy</b>.
            </p>
            <div className="seller-grievance-box">
              <p>
                <strong>Please Note:</strong> The delivery timeframes mentioned
                on this page are approximate estimates calculated from the date
                of dispatch and may vary due to courier delays, customs
                procedures, weather conditions, or other unforeseen
                circumstances beyond our control. Astro Logical Solutions offers
                products based on traditional spiritual, Vedic, and astrological
                practices and beliefs. These products are not intended to
                replace professional medical, legal, or financial advice, and no
                specific result or outcome is guaranteed. For international
                orders, any applicable customs duties, taxes, or import charges
                are the responsibility of the customer and are determined by the
                destination country.
              </p>
            </div>
          </div>
          <div className="seller-grievance-box">
            <h3>Seller Identity &amp; Grievance Redressal</h3>

            <p>
              <strong>Registered Office:</strong> Shiva Aangan, Bachan Singh
              Colony, Lane No.9, Muzaffarnagar, Uttar Pradesh, 251001
            </p>
            <p>
              <strong>Customer Support:</strong>{" "}
              <a href="mailto:support@astrologicalsolutions.in">
                support@astrologicalsolutions.in
              </a>{" "}
              · WhatsApp{" "}
              <a
                href="https://wa.me/7351739191"
                target="_blank"
                rel="noreferrer"
              >
                +91 7351739191
              </a>{" "}
              · Mon–Sat, 10am–7pm IST
            </p>
          </div>
          <section className="delivery-section">
            <div className="delivery-content">
              <h2>Questions about your delivery?</h2>
              <p>
                Our team is here Mon–Sat, 10am–7pm IST. Message us on WhatsApp
                for
                <br className="desktop-break" />
                the fastest response, or explore our Help Center
              </p>
                <div className="delivery-buttons">
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Chat on WhatsApp
                </a>
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Visit Help Center
                </a>
              </div>
            </div>
          </section>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ShippingPolicy;
